import React from 'react';
import { map, get } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { getFieldView } from 'resolvers/form';
import { Icon } from 'modules/icon-bank';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberCheckoutAssigningCoverage as MemberCheckoutAssigningCoverage } from 'ui/views/widgets/memberCheckoutAssigningCoverage';
 *
 * // render
 * <MemberCheckoutAssigningCoverage propName='propValue'/>
 */
export const _memberCheckoutAssigningCoverage = ( props ) => {
    const values = get( props, 'values' );
    const options = get( props, 'options' );
    const fields = get( props, 'fields' );

    return (
        <div className='ui-member-checkout-assigning-coverage'>
            
            {/* widget title */}
            <div className='ui-member-checkout-assigning-coverage__title'>
                <div className='ui-member-checkout-assigning-coverage__title__icon'>
                    <Icon id={ 'coverage' } />
                </div>
                <div className='ui-member-checkout-assigning-coverage__title__text'>
                    { getLabel( props.title ) }
                </div>
            </div>

            {/* widget fields */}
            {
                map( fields, field => {
                    const FieldView = getFieldView( get( field, 'type' ) );
                    
                    return (
                        <FieldView
                            className='ui-member-checkout-assigning-coverage__field'
                            key={ field.name }
                            name={ field.name }
                            label={ field.title }
                            value={ values[ field.name ] }
                            required={ true }
                            placeholder={ field.placeholder }
                            options={ options[ field.options ] }
                            optionsList={ options }
                            onChange={ props.onChange }
                            readonly={ values[ 'readonly' ] }
                            lowerPopoverZIndex={ true }
                        />
                    );
                } )
            }
        </div>
    );
};

// set display name
_memberCheckoutAssigningCoverage.displayName = '_memberCheckoutAssigningCoverage';

// set default props
_memberCheckoutAssigningCoverage.defaultProps = {};

// prop types
_memberCheckoutAssigningCoverage.propTypes = {};


// widget preloader
const memberSavedAddressViewPreloader = () => {
    return (
        <div className='ui-member-checkout-assigning-coverage-preloader'>
            <div className='ui-member-checkout-assigning-coverage-preloader__title'>
                <div className='ui-member-checkout-assigning-coverage-preloader__title__icon'></div>
                <div className='ui-member-checkout-assigning-coverage-preloader__title__text'></div>
            </div>
            <div className='ui-member-checkout-assigning-coverage-preloader__field'>
                <div className='ui-member-checkout-assigning-coverage-preloader__field__label'></div>
                <div className='ui-member-checkout-assigning-coverage-preloader__field__select'></div>
            </div>
        </div>
    );
};

// set display name
memberSavedAddressViewPreloader.displayName = 'memberSavedAddressViewPreloader';

// set default props
memberSavedAddressViewPreloader.defaultProps = {};

// prop types
memberSavedAddressViewPreloader.propTypes = {};


export const memberCheckoutAssigningCoverage = withNetworkState( memberSavedAddressViewPreloader, _memberCheckoutAssigningCoverage );
